<template>
    <Toast />

    <ClientSideDatatable
        :title="'Network Access Lists'" :header-icon="$t('whitelist.icon')"
        :object-name="'whitelists'"
        :endpoint="'/network-access/datatable'"
        :object-id="'id'">
        <template #header-button>
            <a href="javascript:" @click="$goBack" class="text-white">
                <i :class="$t('app_back_icon') + ' mr-2'"></i>Back
            </a>
        </template>
    </ClientSideDatatable>
</template>

<script>
import axios from 'axios';
import Toast from 'primevue/toast';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import {FilterMatchMode, FilterOperator } from '@primevue/core/api';

import { renderCell, formatActions } from '../../composables/datatableCellRenderers.js';
import { handleActionBase, performAction } from '../../composables/useDatatableActions.js';
import { initializeFilters} from "../../composables/useDatatableFiltering";
import {ref} from "vue";
import ClientSideDatatable from "../Datatables/ClientSideDatatable.vue";

export default {
    name: 'WhitelistIndex',

    components: {
        ClientSideDatatable,
        Toast,
        DataTable,
        Column,
        InputText,
        Select,
    },
    data() {
        return {
            data: [],
            columns: [],
            filters: {
                global: {
                    value: null,
                    matchMode: FilterMatchMode.CONTAINS,
                },
            },
            filtersInitialized: false,
            totalRecords: 0,
            loading: true,
        };
    },

    computed: {
        FilterMatchMode: () => FilterMatchMode,

        pageButton() {
            return this.$themeSettings.pageButton;
        },
        pageInfo() {
            return this.$themeSettings.pageInfo;
        },
        pageBox() {
            return this.$themeSettings.pageBox;
        },
        filteredRecords() {
            return this.data.length;
        },

    },

    mounted() {
        this.fetchWhitelists();
    },

    methods: {
        renderCell,
        formatActions,
        handleActionBase,
        initializeFilters,
        fetchWhitelists() {
            this.loading = true;
            axios.get('/network-access/datatable', {
                headers: { Accept: 'application/json' },
            })
                .then(response => {
                    const payload = response.data;
                    this.data = payload.data;
                    this.columns = payload.columns;
                    this.totalRecords = payload.totalRecords;
                    if(!this.filtersInitialized) {
                        this.filters = this.initializeFilters(this.columns);
                        this.filtersInitialized = true;
                    }
                })
                .catch(err => {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to load whitelists',
                        life: 3000,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style scoped>
.p-datatable-thead > tr > th {
    border-width: 1px 1px 2px 1px;
}

.p-datatable-header-cell {
    border-width: 1px 1px 2px 1px !important;
}

.p-datatable-mask {
    background-color: rgba(0, 0, 0, 0.4) !important;
}

.p-inputtext {
    font-size: 0.8rem;
}
</style>
